import {
  FETCH_TEMPLATES_REQUEST,
  FETCH_TEMPLATES_SUCCESS,
  FETCH_TEMPLATES_FAILURE,
  CREATE_TEMPLATES_REQUEST,
  CREATE_TEMPLATES_SUCCESS,
  CREATE_TEMPLATES_FAILURE,
  UPDATE_TEMPLATES_REQUEST,
  UPDATE_TEMPLATES_SUCCESS,
  UPDATE_TEMPLATES_FAILURE,
  DELETE_TEMPLATES_REQUEST,
  DELETE_TEMPLATES_SUCCESS,
  DELETE_TEMPLATES_FAILURE
} from '../actions/templates'

const initialState = {
  templates: [],
  isLoading: false,
  error: null
}

export default function templatesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEMPLATES_REQUEST:
    case CREATE_TEMPLATES_REQUEST:
    case UPDATE_TEMPLATES_REQUEST:
    case DELETE_TEMPLATES_REQUEST:
      return { ...state, isLoading: true }

    case FETCH_TEMPLATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templates: action.payload
      }

    case CREATE_TEMPLATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templates: [...state.templates, action.payload]
      }

    case UPDATE_TEMPLATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templates: state.templates.map(t =>
          t._id === action.payload._id ? action.payload : t
        )
      }

    case DELETE_TEMPLATES_SUCCESS:
      return {
        ...state,
        isLoading: false,
        templates: state.templates.filter(t => t._id !== action.payload)
      }

    case FETCH_TEMPLATES_FAILURE:
    case CREATE_TEMPLATES_FAILURE:
    case UPDATE_TEMPLATES_FAILURE:
    case DELETE_TEMPLATES_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      }

    default:
      return state
  }
}
